import { render, staticRenderFns } from "./PackageSelect.vue?vue&type=template&id=16c676c1&"
import script from "./PackageSelect.vue?vue&type=script&lang=ts&"
export * from "./PackageSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports